export { _fetch } from './fetch';
